import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../../App/App';
import axios from 'axios'
import swal from 'sweetalert'
import jwt from 'jwt-decode'

function CustomerServices() {
    const { stateAuth, dispatchAuth } = useContext(AuthContext)

    const handleClickCard = () => {
        if (jwt(localStorage.getItem('token-helpdesk-umy')).role_id == 1) {
            dispatchAuth({
                type: 'PATH',
                page: 'Customer Services'
            })
        }
    }

    const [state, setstate] = useState({ cs: null })
    useEffect(() => {
        if (state.cs == null) {
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'x-access-token': localStorage.getItem('token-helpdesk-umy')
                }
            }
            axios.get(`/api/v1/helpdesk/dashboard/admins`, config)
                .then(res => {
                    setstate({
                        ...state,
                        cs: res.data.data.admin
                    })
                })
                .catch(err => {
                    if (!err.response || err.code === 'ECONNABORTED') {
                        swal("Error!", "Check Your Internet Connection!", "error", {
                            button: "OK",
                        });
                    } else if (err.response) {
                        if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                            dispatchAuth({
                                type: "LOGOUT",
                                message: 'Token expired, please login again!!!'
                            })
                        } else if (err.response.data.message) {
                            swal("Error!", `${JSON.stringify(err.response.data.message)}`, "error", {
                                button: "OK",
                            });
                        }
                    }
                })
        }
    }, [state])
    return (
        <div className="col-lg-4 col-md-6 col-sm-6 col-12" onClick={handleClickCard} style={{ cursor: 'pointer' }} >
            <div className="card card-statistic-1">
                <div className="card-icon bg-warning">
                    <i className="fas fa-headset" style={{ fontSize: '35px' }}></i>
                </div>
                <div className="card-wrap">
                    <div className="card-header">
                        <h4>Customer Service</h4>
                    </div>
                    <div className="card-body">
                        {state.cs}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CustomerServices
